import { translationsDashboard_da } from "./translationsDashboard.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationsDashboard_en } from "./translationsDashboard.en";

export const translationsDashboard = defineBilingualTranslations({
  da: translationsDashboard_da,
  en: translationsDashboard_en,
});
